import { Component, OnInit, OnDestroy, Renderer2, ElementRef } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { AuthService } from "src/app/core/services/auth.service";
import {
  EmailAuthProvider,
  getAuth,
  getMultiFactorResolver,
  onAuthStateChanged,
  PhoneAuthProvider,
  PhoneMultiFactorGenerator,
  reauthenticateWithCredential,
  RecaptchaVerifier,
} from "firebase/auth";
import { environment } from "src/environments/environment";
import { getApp, getApps, initializeApp } from "firebase/app";
import { MatDialog } from '@angular/material/dialog';
import { OtpComponent } from "../otp/otp.component";
// import { RegisterComponent } from "../register/register.component";
// import { EventService } from "src/app/core/services/event.service";
import { EncryptionService } from "src/app/core/services/encryption.service";
import { EmailLoginComponent } from "../email-login/email-login.component";
import { isSignInWithEmailLink, signInWithEmailLink, getAdditionalUserInfo } from "firebase/auth";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { Observable } from "rxjs";
import { RegisterComponent } from "../register/register.component";
import { PromoVideoComponent } from "src/app/promo-video/promo-video.component";
import { DataService } from "src/app/core/services/data.service";
import { EventService } from "src/app/core/services/event.service";
import { AnalyticsService } from '../../../core/services/analytics.service';
import { ThemeService } from '../../../core/services/theme.service';
import { ToastService } from "src/app/core/services/toast.service";
import { isIOSStandalone } from "src/app/utils/auth.utils";

declare let gtag: (...args: any[]) => void;
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit, OnDestroy {
  isLoading = false;
  currentSlide = 0;
  private slideTimer: any;
  showPassword = false;
  isEventId: any;
  encryptedData: any;
  decryptedData: any;
  eKey: any;
  loginForm = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email]),
    password: new FormControl("", Validators.required),
  });
  email: any;
  fb_user!: Observable<any>;
  emailSent = false;
  errorMessage!: string;
  currentPlatform: string | undefined;
  currentUrl: string;
  hostname: string;
  private authStateUnsubscribe?: () => void;
  constructor(
    private renderer: Renderer2, private el: ElementRef,
    private authService: AuthService, private eventService: EventService,
    private router: Router, public dataService: DataService,
    private encryptionService: EncryptionService,
    public dialog: MatDialog, public fbAuth: AngularFireAuth,
    private analytics: AnalyticsService,
    private toastService: ToastService,
    private themeService: ThemeService,
  ) {
    /**  Get url and redirect to myphotos  **/
    this.currentUrl = new URL(window.location.href).toString();//this.router.url; // Get the current URL
    // console.log(this.currentUrl); //__CONSOLE_LOG__

    // Get hostname from the current URL
    this.hostname = new URL(window.location.href).hostname;
    const parts = this.currentUrl.split('/'); // Split the URL by slashes
    const eventHex = parts[parts.length - 1];
    // console.log(parts, eventHex); //__CONSOLE_LOG__

    if (this.currentUrl.includes('gallery')) {
      // localStorage.setItem('eventId', eventHex);
      localStorage.setItem('access', 'restricted');
      //localStorage.setItem('redirectUrl', '/gallery/'+eventHex);
    }
    else if (this.currentUrl.includes('splash')) {
      localStorage.setItem('openPopup', 'true');
    }

  }


  openVideoPopup(): void {
    const dialogRef = this.dialog.open(PromoVideoComponent, {
      width: '600px',
      disableClose: true // Prevent closing by clicking outside or pressing Escape key
    });
  }


  goTo(n: number) {
    this.currentSlide = n;
    clearInterval(this.slideTimer);
    this.slideTimer = setInterval(() => this.goTo((this.currentSlide + 1) % 5), 4500);
  }

  ngOnDestroy(): void {
    clearInterval(this.slideTimer);
    this.authStateUnsubscribe?.();
    // Hand the theme back to the service rather than restoring an attribute
    // captured on entry. Restoring a snapshot lost the real preference whenever
    // another light-only screen overlapped this one — the second captured the
    // first's forced "light" and put that back, leaving the app light while the
    // switch still read dark.
    this.themeService.reapply();
    // ngOnInit forces showTopBar false for the login page itself and that value
    // persists to localStorage. Routes reached via home/myevents reset it back to
    // true there, but a direct splash → login → event-detail path doesn't pass
    // through either, so event-detail was inheriting this page's "false" and
    // treating it as an intentional signal (e.g. demo-direct-gallery). Clear it
    // here so whatever page comes next starts from the real default.
    localStorage.removeItem('showTopBar');
  }

  ngOnInit() {
    // Login has its own self-contained (light) design — opt it out of the
    // global dark-theme overrides by forcing light theme while it is mounted.
    document.documentElement.setAttribute('data-theme', 'light');

    this.slideTimer = setInterval(() => this.goTo((this.currentSlide + 1) % 5), 4500);
    this.dataService.showTopBar = false;

    this.analytics.capture('login_page_viewed');

    const isDemoUser = localStorage.getItem('isDemoUser') === 'true';
    const isDemoUserName = localStorage.getItem('user_name') === 'DemoDirectGalleryUser';
    if (isDemoUser || isDemoUserName) {
      localStorage.removeItem('isDemoUser');
      localStorage.removeItem('isGuestUser');
      localStorage.removeItem('isHost');
      localStorage.removeItem('showTopBar');
      localStorage.removeItem('eventId');
      localStorage.removeItem('e');
      localStorage.removeItem('u');
      localStorage.removeItem('user_name');
      localStorage.removeItem('user');
      this.fbAuth.signOut();
    }

    var userAgent = navigator.userAgent;
    if (userAgent.match(/iPad|iPhone|iPod/)) {
      // This is likely an iOS device
      // console.log("Apple"); //__CONSOLE_LOG__
      this.currentPlatform = 'Apple';
    } else if (userAgent.match(/Macintosh/) !== null) {
      // console.log("Apple"); //__CONSOLE_LOG__
      this.currentPlatform = 'Apple';
    } else {
      // Not an iOS device
      this.currentPlatform = 'Other';
      // console.log("Other"); //__CONSOLE_LOG__
    }


    if (localStorage.getItem('showLoader')) {
      this.isLoading = true;
      localStorage.removeItem('showLoader');
    }
    this.isEventId = localStorage.getItem('isEventId');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Route has changed
        this.isEventId = localStorage.getItem('isEventId');
      }
    });
    const app = initializeApp(environment.firebase);
    const auth = getAuth(app);
    this.authStateUnsubscribe = onAuthStateChanged(auth, async (user) => {
      const currentUrl = this.router.url || window.location.href;
      const isGuestOrDemoRoute = currentUrl.includes('/guest/') || currentUrl.includes('demo-event') || currentUrl.includes('demo-direct-gallery') || currentUrl.includes('demo-landing');

      // Check for guest/demo routes BEFORE any user checks
      if (isGuestOrDemoRoute) {
        // console.log('Guest/demo route detected, bypassing auth check'); //__CONSOLE_LOG__
        return;
      }

      if (currentUrl.includes('/host?requestId=') || window.location.hash.includes('/host?requestId=')) {
        // console.log('Host transfer route detected'); //__CONSOLE_LOG__
        const hashSearch = window.location.hash.split('?')[1];
        const requestId = hashSearch ? new URLSearchParams(hashSearch).get('requestId') : null;
        if (requestId) {
          localStorage.setItem('pendingHostRedirect', requestId);
        }
      }

      // if (localStorage.getItem('isEventId') == 'true') {
      //   console.log(1);       
      //   this.router.navigateByUrl("/auth/login");
      // }
      // else{
      if (user) {
        // console.log(user); //__CONSOLE_LOG__
        this.encryptedData = this.encryptionService.encryptData(JSON.stringify(user));
        localStorage.setItem('user', this.encryptedData);
        if (user.isAnonymous) {
          this.router.navigateByUrl("/event-detail/false", { replaceUrl: true });
        } else {
          // console.log(localStorage.getItem('redirectUrl') //__CONSOLE_LOG__);

          // Host transfer redirect takes priority over everything else
          const pendingHostRedirect = localStorage.getItem('pendingHostRedirect');
          if (pendingHostRedirect && pendingHostRedirect !== 'null') {
            // localStorage.removeItem('pendingHostRedirect');
            this.router.navigate(['/host'], { queryParams: { requestId: pendingHostRedirect }, replaceUrl: true });
          }
          // Check hostname and query parameters to determine the redirect
          else if (localStorage.getItem('access') === 'restricted') {
            // Redirect to specific page based on conditions
            // this.openVideoPopup();
            if (localStorage.getItem("showGuestInvite")) {
              this.router.navigateByUrl("/event-invite/" + localStorage.getItem('eventId'), { replaceUrl: true });
            }
            else {
              this.router.navigate(['/my-photos/' + localStorage.getItem('eventId')], { replaceUrl: true });
            }
          }
          else if (localStorage.getItem('redirectUrl')) {
            // console.log("redirect to:", localStorage.getItem('redirectUrl') //__CONSOLE_LOG__);
            if (localStorage.getItem('eventId')) {
              let redirectUrl = localStorage.getItem('redirectUrl');
              if (redirectUrl != undefined && redirectUrl?.includes('event-invite'))
                this.router.navigateByUrl("/event-invite/" + localStorage.getItem('eventId'), { replaceUrl: true });
            }
          }
          else if (!localStorage.getItem('redirectUrl') && localStorage.getItem("eventId") && !localStorage.getItem("showGuestInvite")) {

            this.router.navigateByUrl("/event-detail/true", { replaceUrl: true });
          }
          else if (!localStorage.getItem('redirectUrl') && localStorage.getItem('eventId') && localStorage.getItem("showGuestInvite")) {
            this.router.navigateByUrl("/event-invite/" + localStorage.getItem('eventId'), { replaceUrl: true });
          }
          // else if (localStorage.getItem("eventId") && localStorage.getItem('redirectUrl')) {
          //   let redirectUrl = localStorage.getItem('redirectUrl');
          //   if(redirectUrl != undefined && redirectUrl?.includes('event-invite'))
          //   this.router.navigateByUrl("/event-invite/"+localStorage.getItem('eventId'));
          // }
          else if (!localStorage.getItem("eventId")) {
            this.router.navigateByUrl("/home", { replaceUrl: true });
          }

        }
      } else {
        // console.log({ user }); //__CONSOLE_LOG__

        const isGuest = localStorage.getItem('isGuestUser') === 'true';
        const isDemo = localStorage.getItem('isDemoUser') === 'true';
        const currentRouteIsGuestOrDemo = currentUrl.includes('/guest/') || currentUrl.includes('demo-event') || currentUrl.includes('demo-direct-gallery') || currentUrl.includes('demo-landing');
        if (isGuest || isDemo || currentRouteIsGuestOrDemo) {
          return;
        }

        if (this.router.url != "/auth/login" && !localStorage.getItem('ref_eventId')) {
          // console.log('called from login'); //__CONSOLE_LOG__
          this.router.navigateByUrl("/auth/login", { replaceUrl: true });
        } else if (localStorage.getItem('refEventId')) {
          // console.log('splash called from login'); //__CONSOLE_LOG__
          //this.router.navigateByUrl("/splash/" + localStorage.getItem('ref_eventId'));
          this.router.navigateByUrl("/event-detail/false");
        }
        else {
          this.router.navigateByUrl("/auth/login", { replaceUrl: true });
        }
      }
      //    }

    });
  }

  toggleShow(): void {
    this.showPassword = !this.showPassword;
  }

  openLoginDialog() {
    this.dialog.open(EmailLoginComponent);
  }

  trackClick(action: string) {
    gtag('event', action, {
      event_category: 'engagement',
      event_label: 'User Click',
    });
  }


  // signUpWithGoogle() {
  //   // console.log('Signing up with Google...'); //__CONSOLE_LOG__
  //   this.trackClick('signUpWithGoogle');
  //   this.authService
  //     .signUpWithGoogle()
  //     .then((res: any) => {
  //       this.encryptedData = this.encryptionService.encryptData(JSON.stringify(res.user));
  //       localStorage.setItem('user', this.encryptedData);
  //       this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
  //       const app = initializeApp(environment.firebase);
  //       const auth = getAuth(app);
  //       const recaptchaVerifier = new RecaptchaVerifier(
  //         "recaptcha-container",
  //         {
  //           'size': 'invisible',
  //           'callback': (response: any) => {
  //             // reCAPTCHA solved, allow signInWithPhoneNumber.
  //           }
  //         },
  //         auth
  //       );

  //       // const register = this.dialog.open(RegisterComponent, {
  //       //   maxWidth: '100vw',
  //       //   maxHeight: '100vh',
  //       //   height: '100%',
  //       //   width: '100%',
  //       // });

  //       // register.afterClosed().subscribe(async result => {
  //       //   let verificationCode = result;

  //       // });
  //     })
  //     .catch((err) => {
  //       // console.error(err); //__CONSOLE_LOG__
  //       if (err.code == "auth/multi-factor-auth-required") {
  //         const app = initializeApp(environment.firebase);
  //         const auth = getAuth(app);
  //         const recaptchaVerifier = new RecaptchaVerifier(
  //           "recaptcha-container",
  //           {
  //             'size': 'invisible',
  //             'callback': (response: any) => {
  //               // reCAPTCHA solved, allow signInWithPhoneNumber.
  //               // console.log('callback recaptcha') //__CONSOLE_LOG__
  //             },
  //             'expired-callback': () => {
  //               // reCAPTCHA expired. Ask user to solve the reCAPTCHA again.
  //               // This callback is triggered when the reCAPTCHA response expires.
  //               // console.log('expired recaptcha') //__CONSOLE_LOG__
  //             }
  //           },
  //           auth
  //         );
  //         const resolver: any = getMultiFactorResolver(auth, err);
  //         // Ask user which second factor to use.
  //         if (
  //           resolver.hints[0].factorId === PhoneMultiFactorGenerator.FACTOR_ID
  //         ) {
  //           const phoneInfoOptions = {
  //             multiFactorHint: resolver.hints[0],
  //             session: resolver.session
  //           };
  //           const phoneAuthProvider = new PhoneAuthProvider(auth);
  //           // Send SMS verification code
  //           // console.log({ phoneInfoOptions }, { recaptchaVerifier }); //__CONSOLE_LOG__
  //           localStorage.setItem('pNo', phoneInfoOptions.multiFactorHint.phoneNumber);
  //           //  this.isLoading = true;
  //           return phoneAuthProvider
  //             .verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier)
  //             .then(async (verificationId) => {
  //               const dialogRef = this.dialog.open(OtpComponent, {
  //                 maxWidth: '100vw',
  //                 maxHeight: '100vh',
  //                 height: '100%',
  //                 width: '100%'
  //               });

  //               dialogRef.afterOpened().subscribe(() => {
  //                 // When the dialog is opened, change the z-index to bring it to the front
  //                 const dialogContainer = this.renderer.selectRootElement('.fade-background');
  //                 this.renderer.setStyle(dialogContainer, 'z-index', '1');
  //               });

  //               dialogRef.afterClosed().subscribe(async result => {
  //                 //const dialogContainer = this.renderer.selectRootElement('.fade-background');
  //                 //this.renderer.setStyle(dialogContainer, 'z-index', '9999');
  //                 let verificationCode = result;
  //                 const cred = PhoneAuthProvider.credential(
  //                   verificationId, verificationCode);
  //                 const multiFactorAssertion =
  //                   PhoneMultiFactorGenerator.assertion(cred);
  //                 // Complete sign-in.
  //                 const userCredential = await resolver.resolveSignIn(multiFactorAssertion);
  //                 if (!userCredential.user.isAnonymous) {
  //                   this.authService.signIn(userCredential.user, userCredential.user?.reloadUserInfo?.mfaInfo[0]?.phoneInfo).subscribe(
  //                     (data: any) => {
  //                       // localStorage.setItem('userId', data.user_id);
  //                       if (localStorage.getItem('redirectUrl')) {
  //                         // console.log("redirect to:", localStorage.getItem('redirectUrl') //__CONSOLE_LOG__);
  //                         if (localStorage.getItem('eventId')) {
  //                           let redirectUrl = localStorage.getItem('redirectUrl');
  //                           if (redirectUrl != undefined && redirectUrl?.includes('event-invite'))
  //                             this.router.navigateByUrl("/event-invite/" + localStorage.getItem('eventId'), { replaceUrl: true });
  //                         }
  //                       }
  //                       else {
  //                         this.router.navigateByUrl("/home", { replaceUrl: true });
  //                       }

  //                     }
  //                   )
  //                   return userCredential
  //                 }
  //                 // return userCredential;
  //               });
  //             })
  //         } else {
  //           // Unsupported second factor.
  //         }
  //       }
  //       return;
  //     });
  // }

  /**
   * Google/Apple sign-in popups can't complete in an iOS home-screen PWA — see
   * isIOSStandalone() for why. Heading it off here means the user gets an
   * actionable message instead of watching a popup show Firebase's own
   * "missing initial state" error and getting stuck.
   */
  private blockedByStandaloneIOS(): boolean {
    if (!isIOSStandalone()) return false;
    this.toastService.showToast(
      'Sign-in isn\'t supported in the installed app on iPhone/iPad yet. Please open picaggo.com in Safari to sign in.',
      6000
    );
    return true;
  }

  /**
   * Fallback for a Google/Apple sign-in failure that isn't MFA and wasn't
   * already explained above (e.g. blockedByStandaloneIOS()). Previously this
   * branch only logged to a (commented-out) console — the user was left back
   * on the login screen with zero indication anything went wrong. Skips the
   * user-initiated cancel codes, which aren't failures worth surfacing.
   */
  private showGenericSignInError(err: any): void {
    if (err?.code === 'auth/popup-closed-by-user' || err?.code === 'auth/cancelled-popup-request') return;
    this.toastService.showToast('Sign-in didn\'t complete. Please try again.', 4000);
  }

  signUpWithGoogle() {
    // console.log('=== signUpWithGoogle called ==='); //__CONSOLE_LOG__
    this.trackClick('signUpWithGoogle');
    this.analytics.capture('login_provider_clicked', { provider: 'google', surface: 'login_page' });
    if (this.blockedByStandaloneIOS()) return;

    this.authService.signUpWithGoogle()
      .then(async (res: any) => {
        // console.log('Google sign-up success:', res); //__CONSOLE_LOG__

        // The provider popup is gone but sign-in isn't finished (backend signIn,
        // guest linking, then the redirect from onAuthStateChanged). Without this
        // the user is dropped back on the untouched login screen meanwhile.
        this.isLoading = true;

        // Encrypt and store user locally
        this.encryptedData = this.encryptionService.encryptData(JSON.stringify(res.user));
        localStorage.setItem('user', this.encryptedData);
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        // console.log('User data encrypted and stored:', this.decryptedData); //__CONSOLE_LOG__


        // Use existing Firebase app or initialize
        const app = getApps().length ? getApp() : initializeApp(environment.firebase);
        // console.log('Firebase app instance:', app); //__CONSOLE_LOG__

        const auth = getAuth(app);
        // console.log('Firebase auth instance:', auth); //__CONSOLE_LOG__

        // Ensure recaptcha container exists
        const recaptchaContainer = document.getElementById('recaptcha-container');
        if (!recaptchaContainer) {
          // console.error('recaptcha-container element not found!'); //__CONSOLE_LOG__
          return;
        }

        // Setup invisible reCAPTCHA (this is just setup, not actual sign-in completion)
        const recaptchaVerifier = new RecaptchaVerifier(
          'recaptcha-container',
          {
            size: 'invisible',
            callback: (response: any) => {
              // console.log('reCAPTCHA solved:', response); //__CONSOLE_LOG__
            },
            'expired-callback': () => {
              // console.log('reCAPTCHA expired'); //__CONSOLE_LOG__
            }
          },
          auth
        );
        // console.log('RecaptchaVerifier instance:', recaptchaVerifier); //__CONSOLE_LOG__

        // If we reach here without error, user is logged in without MFA
        // Call backend signIn
        const user = res.user._delegate || res.user;
        const isNewUser = res.additionalUserInfo?.isNewUser ?? false;
        (await this.authService.signIn(user, null, isNewUser)).subscribe({
          error: () => {
            this.isLoading = false;
            this.analytics.capture('login_failed', { provider: 'google', mfa: false, reason: 'backend_signin_failed', surface: 'login_page' });
          },
          next: async (data: any) => {
          // console.log('Backend signIn response (no MFA) //__CONSOLE_LOG__:', data);
          this.analytics.capture('login_succeeded', { provider: 'google', mfa: false, is_new_user: isNewUser, surface: 'login_page' });
          localStorage.setItem('skipPolicyBanner', 'true');

          // Link guest user data to authenticated account
          if (localStorage.getItem('isGuestUser') && localStorage.getItem('uid')) {
            // console.log('Linking guest user to authenticated account (no MFA) //__CONSOLE_LOG__...');
            (await this.eventService.linkGuestToUser(localStorage.getItem('uid')!, localStorage.getItem('e')!)).subscribe((linkRes: any) => {
              // console.log('Guest data linked to user:', linkRes); //__CONSOLE_LOG__
              localStorage.removeItem('isGuestUser');
              localStorage.removeItem('uid');
            });
          }

          // Navigation is owned by the onAuthStateChanged listener in ngOnInit —
          // it already covers eventId/showGuestInvite/redirectUrl and fires off the
          // same Firebase auth state change. A second navigateByUrl here raced it and
          // usually won (this callback waits on the backend signIn() call above),
          // sending guests to /home instead of their event.
          }
        });

      })
      .catch(async (err) => {
        // console.error('Error in Google sign-up:', err); //__CONSOLE_LOG__

        if (err.code === "auth/multi-factor-auth-required") {
          // console.log('MFA required:', err); //__CONSOLE_LOG__
          this.analytics.capture('login_mfa_required', { provider: 'google', surface: 'login_page' });

          // Sending the SMS takes a few seconds before the OTP dialog can open —
          // cover that gap so the login screen doesn't look like nothing happened.
          this.isLoading = true;

          const app = getApps().length ? getApp() : initializeApp(environment.firebase);
          const auth = getAuth(app);

          const recaptchaContainer = document.getElementById('recaptcha-container');
          if (!recaptchaContainer) {
            // console.error('recaptcha-container element not found in MFA!'); //__CONSOLE_LOG__
            this.isLoading = false;
            return;
          }

          const recaptchaVerifier = new RecaptchaVerifier(
            'recaptcha-container',
            {
              size: 'invisible',
              callback: (response: any) => console.log('reCAPTCHA solved (MFA):', response),
              'expired-callback': () => console.log('reCAPTCHA expired (MFA)')
            },
            auth
          );
          // console.log('RecaptchaVerifier instance (MFA) //__CONSOLE_LOG__:', recaptchaVerifier);

          // Get MFA resolver
          const resolver: any = getMultiFactorResolver(auth, err);
          // console.log('MFA resolver:', resolver); //__CONSOLE_LOG__

          // Only handle phone factor
          const hint = resolver.hints[0];
          if (hint.factorId === PhoneMultiFactorGenerator.FACTOR_ID) {
            // console.log('Phone MFA selected'); //__CONSOLE_LOG__
            const phoneInfoOptions = { multiFactorHint: hint, session: resolver.session };
            // console.log('Phone info options:', phoneInfoOptions); //__CONSOLE_LOG__

            const phoneAuthProvider = new PhoneAuthProvider(auth);
            localStorage.setItem('pNo', phoneInfoOptions.multiFactorHint.phoneNumber);

            try {
              const verificationId = await phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier);
              // console.log('SMS verificationId:', verificationId); //__CONSOLE_LOG__

              const dialogRef = this.dialog.open(OtpComponent, {
                maxWidth: '100vw',
                maxHeight: '100vh',
                height: '100%',
                width: '100%'
              });

              dialogRef.afterOpened().subscribe(() => {
                // console.log('OTP dialog opened'); //__CONSOLE_LOG__
                // The OTP screen is now on top, so the "sending SMS" loader has done its job.
                this.isLoading = false;
              });

              // afterClosed() only fires once the dialog's close animation has finished,
              // which is long enough to flash the bare login screen. Paint the loader
              // underneath before the OTP screen starts sliding away.
              dialogRef.beforeClosed().subscribe((code) => {
                if (code) { this.isLoading = true; }
              });

              dialogRef.afterClosed().subscribe(async (verificationCode) => {
                // console.log('OTP dialog closed. Code entered:', verificationCode); //__CONSOLE_LOG__

                // Dismissed without a code (backdrop/escape) — nothing to verify.
                if (!verificationCode) {
                  this.isLoading = false;
                  this.analytics.capture('login_otp_dismissed', { provider: 'google', surface: 'login_page' });
                  return;
                }

                // Verifying the code, calling the backend and linking guest data all
                // happen with the login screen back in view — keep the loader up until
                // onAuthStateChanged navigates away.
                this.isLoading = true;

                try {
                  // Create MFA assertion
                  const cred = PhoneAuthProvider.credential(verificationId, verificationCode);
                  const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);
                  // console.log('MultiFactor assertion created'); //__CONSOLE_LOG__

                  // Resolve sign-in
                  const userCredential = await resolver.resolveSignIn(multiFactorAssertion);
                  const user = userCredential.user;
                  // console.log('User signed in with MFA:', user); //__CONSOLE_LOG__

                  if (!user.isAnonymous) {
                    // Refresh user info
                    await user.reload();
                    // console.log('User reloaded after MFA:', user); //__CONSOLE_LOG__

                    const phoneInfo = localStorage.getItem('pNo');// || user.multiFactor.enrolledFactors[0]?.phoneNumber;
                    // console.log('User MFA phoneInfo:', phoneInfo); //__CONSOLE_LOG__

                    // Call backend signIn
                    (await
                      // Call backend signIn
                      this.authService.signIn(user, phoneInfo)).subscribe({
                        error: () => {
                          this.isLoading = false;
                          this.analytics.capture('login_failed', { provider: 'google', mfa: true, reason: 'backend_signin_failed', surface: 'login_page' });
                        },
                        next: async (data: any) => {
                        // console.log('Backend signIn response:', data); //__CONSOLE_LOG__
                        this.analytics.capture('login_succeeded', { provider: 'google', mfa: true, surface: 'login_page' });
                        localStorage.setItem('skipPolicyBanner', 'true');
                        if (localStorage.getItem('isGuestUser') && localStorage.getItem('uid')) {
                          // Link guest data to authenticated user
                          (await this.eventService.linkGuestToUser(localStorage.getItem('uid')!, localStorage.getItem('e')!)).subscribe((res: any) => {
                            // console.log('Guest data linked to user:', res); //__CONSOLE_LOG__
                            localStorage.removeItem('isGuestUser');
                            localStorage.removeItem('uid');
                          });
                        }
                        // Navigation is owned by the onAuthStateChanged listener in ngOnInit — see signUpWithGoogle().
                        }
                      });
                  } else {
                    this.isLoading = false;
                  }
                } catch (otpErr) {
                  // Wrong/expired code — drop the loader so the login screen is usable again.
                  // console.error('Error resolving MFA sign-in:', otpErr); //__CONSOLE_LOG__
                  this.isLoading = false;
                  this.analytics.capture('login_failed', { provider: 'google', mfa: true, reason: 'invalid_otp', surface: 'login_page' });
                }
              });

            } catch (phoneErr) {
              // console.error('Error verifying phone number:', phoneErr); //__CONSOLE_LOG__
              this.isLoading = false;
            }
          } else {
            // console.warn('Unsupported MFA factor:', hint.factorId); //__CONSOLE_LOG__
            this.isLoading = false;
          }
        } else {
          // console.error('Unhandled Firebase error:', err); //__CONSOLE_LOG__
          // Popup closed/cancelled or a real failure — make sure we never strand a spinner.
          this.isLoading = false;
          const cancelled = err?.code === 'auth/popup-closed-by-user' || err?.code === 'auth/cancelled-popup-request';
          this.analytics.capture(cancelled ? 'login_dismissed' : 'login_failed', {
            provider: 'google', surface: 'login_page',
            ...(cancelled ? {} : { code: err?.code, reason: 'provider_error' }),
          });
          this.showGenericSignInError(err);
        }
      });
  }


  async signUpWithApple() {
    // console.log('=== signUpWithApple called ==='); //__CONSOLE_LOG__
    this.trackClick('signUpWithApple');
    this.analytics.capture('login_provider_clicked', { provider: 'apple', surface: 'login_page' });
    if (this.blockedByStandaloneIOS()) return;

    try {
      const res: any = await this.authService.signUpWithApple();
      // console.log('Apple sign-up success:', res); //__CONSOLE_LOG__

      // Provider popup is done, backend work isn't — see signUpWithGoogle().
      this.isLoading = true;

      // Encrypt and store user locally if needed
      if (res.user) {
        this.encryptedData = this.encryptionService.encryptData(JSON.stringify(res.user));
        localStorage.setItem('user', this.encryptedData);
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        // console.log('User data encrypted and stored:', this.decryptedData); //__CONSOLE_LOG__
      }

      // If we reach here without error, user is logged in without MFA
      if (res.user) {
        const user = res.user._delegate || res.user;
        const isNewUser = getAdditionalUserInfo(res)?.isNewUser ?? false;
        (await this.authService.signIn(user, null, isNewUser)).subscribe({
          error: () => {
            this.isLoading = false;
            this.analytics.capture('login_failed', { provider: 'apple', mfa: false, reason: 'backend_signin_failed', surface: 'login_page' });
          },
          next: async (data: any) => {
          // console.log('Backend signIn response (Apple no MFA) //__CONSOLE_LOG__:', data);
          this.analytics.capture('login_succeeded', { provider: 'apple', mfa: false, is_new_user: isNewUser, surface: 'login_page' });
          localStorage.setItem('skipPolicyBanner', 'true');

          // Link guest user data to authenticated account
          if (localStorage.getItem('isGuestUser') && localStorage.getItem('uid')) {
            // console.log('Linking guest user to authenticated account (Apple - no MFA) //__CONSOLE_LOG__...');
            (await this.eventService.linkGuestToUser(localStorage.getItem('uid')!, localStorage.getItem('e')!)).subscribe((linkRes: any) => {
              // console.log('Guest data linked to user (Apple) //__CONSOLE_LOG__:', linkRes);
              localStorage.removeItem('isGuestUser');
              localStorage.removeItem('uid');
            });
          }
          // Navigation is owned by the onAuthStateChanged listener in ngOnInit — see signUpWithGoogle().
          }
        });
      } else {
        this.router.navigateByUrl("/home", { replaceUrl: true });
      }

    } catch (err: any) {
      // console.error('Apple login error:', err); //__CONSOLE_LOG__

      if (err.code === "auth/multi-factor-auth-required") {
        // console.log('MFA required for Apple login:', err); //__CONSOLE_LOG__
        this.analytics.capture('login_mfa_required', { provider: 'apple', surface: 'login_page' });

        // Cover the SMS round-trip before the OTP dialog appears — see signUpWithGoogle().
        this.isLoading = true;

        // Use existing Firebase app or initialize
        const app = getApps().length ? getApp() : initializeApp(environment.firebase);
        const auth = getAuth(app);
        // console.log('Firebase auth instance for MFA:', auth); //__CONSOLE_LOG__

        // Ensure global recaptcha container exists
        if (!document.getElementById('recaptcha-container')) {
          // console.error('recaptcha-container element not found!'); //__CONSOLE_LOG__
          this.isLoading = false;
          return;
        }

        // Clear old verifier if any
        if (window.recaptchaVerifier) {
          window.recaptchaVerifier.clear();
        }

        const recaptchaVerifier = new RecaptchaVerifier(
          'recaptcha-container',
          {
            size: 'invisible',
            callback: (response: any) => console.log('reCAPTCHA solved (Apple MFA):', response),
            'expired-callback': () => console.log('reCAPTCHA expired (Apple MFA)')
          },
          auth
        );
        window.recaptchaVerifier = recaptchaVerifier;
        // console.log('RecaptchaVerifier instance (Apple MFA) //__CONSOLE_LOG__:', recaptchaVerifier);

        // Handle multi-factor resolver
        const resolver: any = getMultiFactorResolver(auth, err);
        // console.log('MFA resolver:', resolver); //__CONSOLE_LOG__

        const hint = resolver.hints[0];
        if (hint.factorId === PhoneMultiFactorGenerator.FACTOR_ID) {
          // console.log('Phone MFA selected'); //__CONSOLE_LOG__
          const phoneInfoOptions = { multiFactorHint: hint, session: resolver.session };
          // console.log('Phone info options:', phoneInfoOptions); //__CONSOLE_LOG__

          const phoneAuthProvider = new PhoneAuthProvider(auth);
          localStorage.setItem('pNo', phoneInfoOptions.multiFactorHint.phoneNumber);

          try {
            const verificationId = await phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier);
            // console.log('SMS verificationId:', verificationId); //__CONSOLE_LOG__

            const dialogRef = this.dialog.open(OtpComponent, {
              maxWidth: '100vw',
              maxHeight: '100vh',
              height: '100%',
              width: '100%'
            });

            dialogRef.afterOpened().subscribe(() => {
              // console.log('OTP dialog opened (Apple MFA) //__CONSOLE_LOG__');
              // The OTP screen is now on top, so the "sending SMS" loader has done its job.
              this.isLoading = false;
            });

            // Paint the loader before the close animation — see signUpWithGoogle().
            dialogRef.beforeClosed().subscribe((code) => {
              if (code) { this.isLoading = true; }
            });

            dialogRef.afterClosed().subscribe(async (verificationCode) => {
              // console.log('OTP dialog closed. Code entered:', verificationCode); //__CONSOLE_LOG__

              // Dismissed without a code (backdrop/escape) — nothing to verify.
              if (!verificationCode) {
                this.isLoading = false;
                this.analytics.capture('login_otp_dismissed', { provider: 'apple', surface: 'login_page' });
                return;
              }

              // Keep the loader up over the verify + backend call — see signUpWithGoogle().
              this.isLoading = true;

              try {
                const cred = PhoneAuthProvider.credential(verificationId, verificationCode);
                const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);
                // console.log('MultiFactor assertion created (Apple MFA) //__CONSOLE_LOG__');

                const userCredential = await resolver.resolveSignIn(multiFactorAssertion);
                const user = userCredential.user;
                // console.log('User signed in with MFA (Apple) //__CONSOLE_LOG__:', user);

                if (!user.isAnonymous) {
                  await user.reload();
                  const phoneInfo = user.multiFactor.enrolledFactors[0]?.phoneNumber;
                  // console.log('User MFA phoneInfo (Apple) //__CONSOLE_LOG__:', phoneInfo);

                  (await this.authService.signIn(user, phoneInfo)).subscribe({
                    error: () => {
                      this.isLoading = false;
                      this.analytics.capture('login_failed', { provider: 'apple', mfa: true, reason: 'backend_signin_failed', surface: 'login_page' });
                    },
                    next: async (data: any) => {
                    // console.log('Backend signIn response (Apple MFA) //__CONSOLE_LOG__:', data);
                    this.analytics.capture('login_succeeded', { provider: 'apple', mfa: true, surface: 'login_page' });
                    localStorage.setItem('skipPolicyBanner', 'true');
                    if (localStorage.getItem('isGuestUser') && localStorage.getItem('uid')) {
                      // Link guest data to authenticated user
                      (await this.eventService.linkGuestToUser(localStorage.getItem('uid')!, localStorage.getItem('e')!)).subscribe((res: any) => {
                        // console.log('Guest data linked to user:', res); //__CONSOLE_LOG__
                        localStorage.removeItem('isGuestUser');
                        localStorage.removeItem('uid');
                      });
                    }
                    // Navigation is owned by the onAuthStateChanged listener in ngOnInit — see signUpWithGoogle().
                    }
                  });
                } else {
                  this.isLoading = false;
                }
              } catch (otpErr) {
                // Wrong/expired code — drop the loader so the login screen is usable again.
                // console.error('Error resolving MFA sign-in (Apple) //__CONSOLE_LOG__:', otpErr);
                this.isLoading = false;
                this.analytics.capture('login_failed', { provider: 'apple', mfa: true, reason: 'invalid_otp', surface: 'login_page' });
              }
            });

          } catch (phoneErr) {
            // console.error('Error verifying phone number (Apple MFA) //__CONSOLE_LOG__:', phoneErr);
            this.isLoading = false;
          }

        } else {
          // console.warn('Unsupported MFA factor (Apple) //__CONSOLE_LOG__:', hint.factorId);
          this.isLoading = false;
        }
      } else {
        // Popup closed/cancelled or a real failure — never strand a spinner.
        this.isLoading = false;
        const cancelled = err?.code === 'auth/popup-closed-by-user' || err?.code === 'auth/cancelled-popup-request';
        this.analytics.capture(cancelled ? 'login_dismissed' : 'login_failed', {
          provider: 'apple', surface: 'login_page',
          ...(cancelled ? {} : { code: err?.code, reason: 'provider_error' }),
        });
        this.showGenericSignInError(err);
      }
    }
  }
  // async signUpWithApple() {
  //   // console.log('Signing up with Apple...'); //__CONSOLE_LOG__
  //   this.trackClick('signUpWithApple');
  //   try {
  //     await this.authService.signUpWithApple().then((res) => {

  //       this.router.navigateByUrl("/home");
  //     })
  //       .catch((err) => {
  //         // console.error(err); //__CONSOLE_LOG__
  //       });
  //     // console.log('apple login successful'); //__CONSOLE_LOG__

  //   } catch (error) {
  //     // console.log('apple login error:', error); //__CONSOLE_LOG__
  //   }
  // }

  signInAnonymously() {
    this.authService
      .signInAnonymously()
      .then((res) => {
        //console.log({res});

        this.encryptedData = this.encryptionService.encryptData(JSON.stringify(res.user));
        localStorage.setItem('user', this.encryptedData);
        localStorage.setItem('isEventId', 'false');
        // this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        this.router.navigateByUrl("/event-detail/false", { replaceUrl: true });
      })
      .catch((err) => {
        // console.error(err); //__CONSOLE_LOG__
      });
  }


  async confirmSignIn(url: any) {
    let _email: any;
    try {
      if (await this.fbAuth.isSignInWithEmailLink(url)) {
        _email = window.localStorage.getItem('emailForSignIn');

        // If missing email, prompt user for it
        if (!_email) {
          _email = window.prompt('Please provide your email for confirmation');
        }

        // Signin user and remove the email localStorage
        const result = await this.fbAuth.signInWithEmailLink(_email, url);
        window.localStorage.removeItem('emailForSignIn');
      }
    } catch (err: any) {
      this.errorMessage = err.message;
    }
  }


}